import { Component, OnInit } from '@angular/core';
import { CentralGuard } from 'src/app/core/guards/central.guard'
import { ActivatedRoute, NavigationExtras, ParamMap, Params, Router } from '@angular/router';
import { ADMIN_ROUTER } from 'src/app/shared/constants/app-router';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserInfo } from 'src/app/shared/models/user-info.model';

@Component({
	selector: 'app-side-bar',
	templateUrl: './side-bar.component.html',
	styleUrls: ['./side-bar.component.scss'],
})
export class SideBarComponent implements OnInit {
	public display = true;
	public readonly ADMIN_ROUTER = ADMIN_ROUTER;

	public stateParam: Params = { state: "" };
	public isDevUser = false;

	constructor(private router: Router, private route: ActivatedRoute, private centralGuard: CentralGuard, private authService: AuthService) {
	}

	public isActive(module: string): string {
		return this.router.url.includes(module) ? 'active' : '';
	}

	public trackByFn(index: number): number {
		return index;
	}

	public navigateToPage(link: string): void {
		this.router.navigate([`admin/${link}`], { queryParams: this.stateParam });
	}

	public sortByIndex(modules: any[]) {
		return modules.sort((a, b) => (a.value.INDEX > b.value.INDEX) ? 1 : -1)
	}


	public canShowModule(module: any): boolean {
		// ✅ Only restrict Log Download
		if (module.value.ROUTER === this.ADMIN_ROUTER.LOG_DOWNLOAD.ROUTER) {
			return this.isDevUser;
		}

		// ✅ All other modules unchanged
		return true;
	}


	ngOnInit() {
		this.route.queryParamMap
			.subscribe(paramMap => {
				if (paramMap.has(this.centralGuard.validationQueryParameter)) {
					this.stateParam[this.centralGuard.validationQueryParameter] = paramMap.get(this.centralGuard.validationQueryParameter);
				}
			}
			);


		this.authService.getCurrentUser().subscribe((user: UserInfo) => {
			this.isDevUser = !!user?.isDevUser;
		});

	}

}
